import { useLanguage } from "../context/LanguageContext";
import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export default function LanguageSelector() {
  const { language, setLanguage, languageNames, languageFlags } = useLanguage();

  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger 
        className="w-auto gap-2 bg-white/5 border-white/10 text-white hover:bg-white/10 focus:ring-0 focus:ring-offset-0"
        data-testid="language-selector"
      >
        <Globe className="w-4 h-4 text-neon-cyan" />
        <SelectValue>
          <span className="flex items-center gap-2">
            <span>{languageFlags[language]}</span>
            <span className="hidden sm:inline">{languageNames[language]}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-surface-card border-white/10">
        {Object.keys(languageNames).map((lang) => (
          <SelectItem 
            key={lang} 
            value={lang}
            className="text-white hover:bg-white/10 focus:bg-white/10 cursor-pointer"
            data-testid={`language-option-${lang}`}
          >
            <span className="flex items-center gap-2">
              <span>{languageFlags[lang]}</span>
              <span>{languageNames[lang]}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
